import { DeviceType } from 'src/common/enumerations/device-type';
import { store } from 'src/common/redux/configure-store';
import { IActionButton } from '../../common/interfaces/dtos/ICashOfficeActionButton';
import { UserActions } from '../interfaces/UserActions';
import { HandleCashOfficeActions } from './handle-cash-office-actions';
import { PaidAccountType } from './services/get-paid-accounts';

// like the priceOverride button, all the buttons should be generated based on the POS config eventually
//move this file somewhere better
export const generateCashOfficeActionButtons = (): IActionButton[] => {
  return [
    {
      id: 'paid-in-action-button',
      text: 'PaidInCommand',
      handleClick: () =>
        HandleCashOfficeActions.showPaidAccountSelectionView(PaidAccountType.PaidIn),
      isDisabled: !isCashOfficeButtonEnabled('paid-in-action-button'),
    },
    {
      id: 'paid-out-action-button',
      text: 'PaidOutCommand',
      handleClick: () =>
        HandleCashOfficeActions.showPaidAccountSelectionView(PaidAccountType.PaidOut),
      isDisabled: !isCashOfficeButtonEnabled('paid-out-action-button'),
    },
    {
      id: 'tender-pickup-action-button',
      text: 'TenderPickup',
      handleClick: HandleCashOfficeActions.openTenderPickupActionView,
      isDisabled: !isCashOfficeButtonEnabled('tender-pickup-action-button'),
    },
    {
      id: 'declaration-action-button',
      text: 'DeclarationCommand',
      handleClick: HandleCashOfficeActions.openDeclarationActionView,
      isDisabled: !isCashOfficeButtonEnabled('declaration-action-button'),
    },
    {
      id: 'till-closing-action-button',
      text: 'TillClosingCommand',
      handleClick: HandleCashOfficeActions.performTillClosing,
      isDisabled: !isCashOfficeButtonEnabled('till-closing-action-button'),
    },
    {
      id: 'loan-add-action-button',
      text: 'AddLoanCommand',
      handleClick: HandleCashOfficeActions.openLoanAddActionView,
      isDisabled: !isCashOfficeButtonEnabled('loan-add-action-button'),
    },
    {
      id: 'blind-pickup-action-button',
      text: 'BlindPickupCommand',
      handleClick: HandleCashOfficeActions.handleBlindPickup,
      isDisabled: !isCashOfficeButtonEnabled('blind-pickup-action-button'),
    },
  ];
};

export const isCashOfficeButtonEnabled = (buttonId: string): boolean => {
  const cashOfficeUserActions: UserActions = HandleCashOfficeActions.cashOfficeAccess();
  const hasCashDrawer = store
    .getState()
    .deviceStatus.devices.find(i => i.deviceType === DeviceType.CashDrawer);

  switch (buttonId) {
    case 'paid-in-action-button':
      return cashOfficeUserActions.allActions || cashOfficeUserActions.paidIn;
    case 'paid-out-action-button':
      return cashOfficeUserActions.allActions || cashOfficeUserActions.paidOut;
    case 'tender-pickup-action-button':
      return cashOfficeUserActions.allActions || cashOfficeUserActions.tenderPickup;
    case 'declaration-action-button':
      return cashOfficeUserActions.allActions || cashOfficeUserActions.tillDeclaration;
    case 'till-closing-action-button':
      return !!(
        (cashOfficeUserActions.allActions || cashOfficeUserActions.tillClosing) &&
        hasCashDrawer &&
        hasCashDrawer.initialized
      );
    case 'loan-add-action-button':
      return cashOfficeUserActions.allActions || cashOfficeUserActions.loanAdd;
    case 'till-closing-login-button':
    case 'open-cash-drawer-login-button':
      return !!(hasCashDrawer && hasCashDrawer.initialized);
    case 'blind-pickup-action-button':
      return cashOfficeUserActions.allActions || cashOfficeUserActions.blindPickup;
    default:
      return false;
  }
};
